import React from "react";
import { Box, Paper, Skeleton } from "@mui/material";

const SitterCardSkeleton: React.FC = () => {
  return (
    <Paper elevation={1} sx={{ p: 2.5, mb: 2 }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "flex-start", mb: 1.5 }}>
        <Skeleton variant="circular" width={56} height={56} sx={{ mr: 2 }} />
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={28} />
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="70%" height={18} />
            </Box>
            <Box>
              <Skeleton variant="text" width={60} height={28} />
              <Skeleton variant="text" width={60} height={18} />
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Review Snippet */}
      <Skeleton variant="text" width="100%" />
      <Skeleton variant="text" width="90%" sx={{ mb: 2 }} />

      {/* Buttons */}
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Skeleton variant="rounded" height={36} sx={{ flex: 1 }} />
        <Skeleton variant="rounded" height={36} sx={{ flex: 1 }} />
      </Box>
    </Paper>
  );
};

export default SitterCardSkeleton;
